/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { JobStageRestService, newJobStageListItem } from '@gh/builder-shared-data';
import { EntityInputDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { JobStageListItem, jobStageListToOrder, JobStagesFilter } from './job-stages.model';

@Injectable()
export class JobStageListBusinessService implements InitViewService,
                                                    InitDialogViewService<EntityInputDialogConfig<JobStageListItem>> {
  constructor(private restService: JobStageRestService) {

  }

  create(item: JobStageListItem): Observable<JobStageListItem> {
    return this.restService.create(item);
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      stagesList: this.findAll({ showDeleted: false }),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<JobStageListItem>>): any {
    return route.input.id ? this.get(route.input.id) : this.prepareForCreate();
  }

  get(itemId: ID): Observable<JobStageListItem> {
    return this.restService.get(itemId);
  }

  delete(item: JobStageListItem): Observable<JobStageListItem> {
    return this.restService.deactivateOrDelete(item);
  }

  findAll(filter: JobStagesFilter): Observable<JobStageListItem[]> {
    return this.restService.findAll(filter);
  }

  prepareForCreate(): newJobStageListItem {
    return {
      name: '',
    };
  }

  undelete(item: JobStageListItem): Observable<JobStageListItem> {
    return this.restService.undelete(item);
  }

  updateJobStages(jobStages: JobStageListItem[]): Observable<JobStageListItem[]> {
    return this.restService.updateJobStages(jobStageListToOrder(jobStages));
  }

  update(item: JobStageListItem): Observable<JobStageListItem> {
    return this.restService.update(item);
  }
}
